// extracted by mini-css-extract-plugin
export default {"container":"LabelSignalDialog_container__kf2SK","checkbox":"LabelSignalDialog_checkbox__xOSJF"};